export default class MapHotelsStore {
	#data

	constructor() {
		this.syncData()
	}

	#collectData() {
		return [...document.querySelectorAll('.js-bhotel-item')].map(hotel => {
			return {
				id: hotel.dataset.bhotelId || '',
				lat: hotel.dataset.lat || '',
				lng: hotel.dataset.lng || '',
				name: hotel.dataset.name || '',
				price: hotel.dataset.price || '',
				biggerPrice: hotel.dataset.biggerPrice || '',
				number: hotel.dataset.number || '',
				stars: hotel.dataset.stars || '',
				photo: hotel.dataset.photo || '',
				rating: hotel.dataset.rating || '',
				reviewPhrase: hotel.dataset.reviewPhrase || '',
				reviewsCount: hotel.dataset.reviewsCount || '',
			}
		})
	}

	syncData() {
		this.#data = this.#collectData()
	}

	getData() {
		return this.#data
	}

	getCoordinates() {
		return this.#data
			.filter(item => item.lng && item.lat)
			.map(item => [item.lng, item.lat])
	}

	findHotelByID(id) {
		return this.#data.find(hotel => hotel.id === id)
	}
}
